import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const NAV_OFFSET = -80;

const scrollWindowTop = (immediate = true) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(0, { immediate, duration: immediate ? 0 : 1.1 });
  }
  window.scrollTo({ top: 0, left: 0, behavior: immediate ? "auto" : "smooth" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) {
    scrollWindowTop(true);
    return;
  }
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: NAV_OFFSET, immediate: false });
    return;
  }
  el.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" });
};

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useLayoutEffect(() => {
    if (hash) return;
    scrollWindowTop(true);
  }, [pathname, hash]);

  useEffect(() => {
    if (!hash) return;
    const id = decodeURIComponent(hash.replace("#", ""));
    const t = window.setTimeout(() => scrollToId(id), 80);
    return () => window.clearTimeout(t);
  }, [pathname, hash]);

  useEffect(() => {
    const onClick = (event) => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      const anchor = event.target.closest("a[href]");
      if (!anchor) return;
      const href = anchor.getAttribute("href");
      if (!href || href.startsWith("mailto:") || href.startsWith("tel:")) return;

      let url;
      try {
        url = new URL(href, window.location.href);
      } catch {
        return;
      }
      if (url.origin !== window.location.origin) return;

      if (url.hash) {
        const id = decodeURIComponent(url.hash.slice(1));
        if (url.pathname === window.location.pathname) {
          event.preventDefault();
          if (id === "top") {
            scrollWindowTop(false);
          } else {
            scrollToId(id);
          }
          if (url.hash !== window.location.hash) {
            window.history.pushState(null, "", url.hash);
          }
        }
        return;
      }

      if (url.pathname === window.location.pathname) {
        scrollWindowTop(false);
      }
    };

    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  return null;
};
